import { render, staticRenderFns } from "./product-view.vue?vue&type=template&id=3c419d21&scoped=true&"
import script from "./product-view.vue?vue&type=script&lang=js&"
export * from "./product-view.vue?vue&type=script&lang=js&"
import style0 from "./product-view.vue?vue&type=style&index=0&id=3c419d21&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c419d21",
  null
  
)

export default component.exports